import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import HistoricalScores from '../components/HistoricalScores';
import { fetchObservations } from '../actions/observations';
import { inProgress } from '../api/observations';

let mapStateToProps = function(state) {
	return {
		observations: state.observations.list
	};
};

let mapDispatchToProps = {
	fetchObservations,
	inProgress
};

module.exports = connect(mapStateToProps, mapDispatchToProps)(HistoricalScores);



// WEBPACK FOOTER //
// ./frontend/olos/js/containers/HistoricalScores.jsx